// kfe-brainsoaking-fam-meter.js — BrainSoaking Familiarity meter (type 19).
//
// iOS REFERENCE: KFEBrainSoakingFamMetVC — TWO 0–100% sliders (Q1 % familiar,
// Q2 % known/understood) with the constraint answer2 ≤ answer1
// (KFEBrainSoakingFamMetVC.m:248); on violation a transient warning shows. It
// has NO thresholds and NO affected item (the VM zeroes them, m:367-378) and NO
// feedback screen — it records the answers and dismisses directly (m:261-271).
// This is the canonical Function-B / telemetry-only meter.
//
// Brief 055: collects answer1 + answer2, validates a2 ≤ a1, then dispatches
// kfe:meter-complete { answer1, answer2 } straight away (no feedback phase).

import { html } from "../core/html.js";
import { t } from "../core/i18n.js";
import { KFEMeterBase, METER_MODAL_STYLES } from "./kfe-meter-base.js";

export class KFEBrainsoakingFamMeter extends KFEMeterBase {
  static styles = METER_MODAL_STYLES;

  constructor() {
    super();
    this._answer1 = 0;
    this._answer2 = 0;
    this._warn = false;
  }

  _confirm() {
    if (this._answer2 > this._answer1) {
      // answer2 (understood) cannot exceed answer1 (familiar).
      this._warn = true;
      this._scheduleRender();
      return;
    }
    // iOS dismisses BrainSoaking directly — no pass/fail feedback screen.
    this._complete(this._answer1, this._answer2);
  }

  render() {
    const card = document.createElement("div");
    card.className = "card";

    const h2 = document.createElement("h2");
    h2.textContent = this._title();
    card.appendChild(h2);

    const warning = document.createElement("p");
    warning.className = "warning";
    warning.setAttribute("role", "alert");
    warning.textContent = this._warn ? t("meter.brainsoaking.warning") : "";
    card.appendChild(warning);

    card.appendChild(this._sliderBlock(
      t("meter.brainsoaking.prompt1"),
      t("meter.brainsoaking.sliderHint1"),
      this._answer1,
      (v) => { this._answer1 = v; },
    ));
    card.appendChild(this._sliderBlock(
      t("meter.brainsoaking.prompt2"),
      t("meter.brainsoaking.sliderHint2"),
      this._answer2,
      (v) => { this._answer2 = v; },
    ));

    const actions = document.createElement("div");
    actions.className = "actions";
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "confirm";
    btn.textContent = t("meter.confirm");
    btn.addEventListener("click", () => this._confirm());
    actions.appendChild(btn);
    card.appendChild(actions);

    return html`${card}`;
  }
}
